// extracted by mini-css-extract-plugin
export default {"link":"WN-z","disabled":"XN-z"};